import { t } from "@client/lib/dictionary";

/**
 * Vytáhne user-facing hlášku z axios chyby volání kamery.
 * Server posílá důvod v `message` (např. „Kamera odmítla příkaz (účet nemá
 * dostatečná práva).") — je konkrétnější než jakýkoli obecný fallback.
 */
export function foscamErrMsg(err: unknown): string {
  const m = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
  return m ?? t.foscam.unavailable;
}
